<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-body>
                <div class="row">
                    <b-col align="right" >
                        <b-button type="button" variant="success"  @click='showPaymensDialog=true'><i class="fa fa-plus"></i> Провести платеж</b-button>
                        <br><br>
                    </b-col>
                </div>

                <b-row>
                    <b-col md="6">
                        <b-form-group label="Период (по дате выписки):" :label-cols="3" :horizontal="false">
                            <div class="input-group">
                                <v-date-picker
                                    id="rangeCISelect"
                                    mode='range'
                                    v-model='rangeFilter'
                                    @change="applyRangeFilter()"
                                    @input="applyRangeFilter()"
                                    :attributes="datepicker_attributes"
                                >
                                    <b-form-input
                                        type="text"
                                        id="range_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        v-bind="inputProps"
                                        v-on="inputEvents" />
                                </v-date-picker>
                                <b-button type="button" variant="secondary"  @click='resetRangeFilter()'><i class="cui-circle-x icon"></i> </b-button>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="Контрагент"  :label-cols="3" :horizontal="false">
                            <v-select
                                v-model="contractorFilter"
                                :options="getCompanies()"
                                placeholder="Выберите контрагента"
                                v-validate="{required:true,}"
                                label="title"
                                data-vv-name="contractor"
                                data-vv-as="Контрагент"
                                @input="applyContractorFilter()"
                                class="form-contol"
                            ></v-select>
                        </b-form-group>
                    </b-col>


                    <b-col md="6">
                        <b-form-group label="Тип платежа" :label-cols="3" :horizontal="false" >
                            <div class="input-group">
                                <b-select
                                    :options="get_types"
                                    v-model="typeFilter"
                                    value-field="id"
                                    text-field="title"
                                    @input="applyTypeFilter()"
                                ></b-select>
                                <b-button type="button" variant="secondary"  @click='resetTypeFilter()'><i class="cui-circle-x icon"></i> </b-button>
                            </div>
                        </b-form-group>
                    </b-col>

                </b-row>

                <b-row>
                    <b-col class="text-right">
                        <b-form-group>
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="enabled"
                                    value="1"
                                    @input="applyBindingFilter()"
                                    v-model="bindingFilter">
                                <label class="custom-control-label" for="enabled">Скрыть разнесенные {{ bindingFilter }}</label>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>

                <v-server-table :url="apiurl('payment/table')"  :columns="columns" :options="options" :theme="theme" id="paymentsTable" ref="paymentsTable" >
                    <span slot="type" slot-scope="props">
                        {{ paymentTypeText(props.row.type) }}
                    </span>
                    <span slot="amount" slot-scope="props" :class="isIncome(props.row.type)?'':'text-danger'">
                        <template v-if="!isIncome(props.row.type)">-</template>{{ formatPriceKop(props.row.amount) }}
                    </span>
                    <div slot="child_row" slot-scope="props">
                        <h3>Платеж № {{props.row.id}} проведен {{props.row.created_at}} </h3>
                        <p>
                            Компания: {{ props.row.company_id }}<br>
                            Оператор: {{ props.row.operator_id }}<br>
                            Контрагент: {{ props.row.contractor_id }} (для расчетов системы)<br>
                            Заказчик: {{ props.row.customer_id }} (для расчетов агентства)<br>
                            Тип платежа: {{ paymentTypeText(props.row.type) }}<br>
                            Сумма платежа: {{ formatPriceKop(props.row.amount) }}<br>
                            Платежное поручение: {{ props.row.document_number }} от {{ printDate(props.row.document_date) }}<br>
                            Счет к оплате: {{ props.row.invoice_number }} от {{ printDate(props.row.invoice_date) }}<br>
                            Банковская выписка: {{ props.row.statement_number }} от {{ printDate(props.row.statement_date) }}<br>
                            Договор: {{ props.row.contract }} <br>
                            Информация о платеже: {{ props.row.info }}<br>
                            UUID 1C: {{ props.row.uuid1c }}<br>
                            Проводка в системе: {{ props.row.finance_id }}<br>
                            Плательщик ИНН/КПП: {{ props.row.payer_inn }}/{{ props.row.payer_kpp }}<br>
                            Получатель платежа ИНН/КПП: {{ props.row.payee_inn }}/{{ props.row.payee_kpp }}<br>
                            Информация о брони: {{ props.row.booking_info }}<br>
                            <a :href="$router.resolve({ path:bookingPage(props.row.booking_info)}).href">{{ props.row.booking_info }}</a><br>
                            Информация о счете/путевке: {{ props.row.voucher_info }}<br>

                        </p>
                        <h3>Привязанные брони</h3>
                        <ul>
                            <li v-for="r in props.row.booking_relatons">Бронь
                                <a :href="$router.resolve({ path:bookingPage(r.booking_id)}).href">#{{ r.booking_id }}</a>
                                на сумму {{ formatPriceKop(r.value) }}</li>
                        </ul>

                    </div>
                    <span slot="created_at" slot-scope="props">
                        {{ printDateTime(props.row.created_at, true) }}
                    </span>
                    <span slot="document_date" slot-scope="props">
                        {{ printDate(props.row.document_date) }}
                    </span>
                    <span slot="statement_date" slot-scope="props">
                        {{ printDate(props.row.statement_date) }}
                    </span>
                    <span slot="voucher_info" slot-scope="props">
                        {{ props.row.voucher_info }}
                    </span>

                    <span slot="binded" slot-scope="props">
                        <template v-if="props.row.binded">
                            <a href="#" @click.prevent="bindPayment(props.row)"><i class="icon-shuffle text-success"></i></a>
                        </template>
                        <template v-else>
                            <a href="#" @click.prevent="bindPayment(props.row)"><i class="icon-shuffle text-danger"></i></a>
                        </template>
                    </span>

                    <template slot="bottom-row" slot-scope="data">
                        <td>Total</td>
                        <td>{{total}}</td>
                    </template>

                    <tr slot="appendBody">
                        <th colspan="10">ИТОГО ПО СТРАНИЦЕ</th>
                        <th style="text-align:right!important;" :class="total<0?'text-danger':''">{{ formatPriceKop(total) }}</th>
                    </tr>
                </v-server-table>
            </b-card-body>
        </b-card>
        <payments-dialog v-model="showPaymensDialog" @payment_uploaded="onPaymentUploaded" @payment_created="onPaymentCreated"></payments-dialog>
        <bind-payment-dialog v-model="showBindPaymenDialog" @payment_saved="onPaymentSaved" :paymentx="payment_in_edit"
                             v-if="showBindPaymenDialog" @ok="onCloseBindPaymenDialog('ok')"
                             @cancel="onCloseBindPaymenDialog('cancel')"
                             @close="onCloseBindPaymenDialog('close')"
                             @hide="onCloseBindPaymenDialog('hide')"
        ></bind-payment-dialog>

        <b-modal title="Результат загрузки выписок" size='xl' class="modal-danger" centered  v-model="showUpladResultModal" ok-variant="secondary" v-if="upload_result">


            Зaгруженный файл: <strong>{{ upload_result.file }}</strong><br>
            Загружено: {{ $tc('statement', upload_result.loaded) }}.<br>
            Дубликатов: {{ $tc('statement', upload_result.dublicates) }}.
            Не загружено: {{ $tc('statement', upload_result.failed) }}.

            <table v-if="upload_result.errors" class="table table-bordered table-hover table-striped table-sm">
                <tr v-for="e in upload_result.errors">
                    <td>{{e.error}}</td>
                    <td>{{e.info}}</td>
                    <td>{{e.uuid1c}}</td>
                    <td>{{e.scope}}</td>
                </tr>

            </table>

            <template slot="modal-footer" slot-scope="{ cancel, hide }"></template>
        </b-modal>

    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import { functions_payments } from '@/functions/payments.js';
    import {CONSTANTS} from '@/constants';
    import PaymentsDialog from '@/dialogs/PaymentsDialog';
    import BindPaymentDialog from '@/dialogs/BindPaymentDialog';
    import vSelect from 'vue-select';
    Vue.use(ServerTable)

    export default {
        name: 'NsbBuhPayments',
        components: { ServerTable, Event, PaymentsDialog, vSelect, BindPaymentDialog },
        mixins: [functions, functions_loaders, functions_company, functions_payments],
        data: function () {
            return {
                columns: [
                    'id', 'type', 'cash', 'contractor.title', 'document_number', 'document_date', 'statement_number', 'statement_date', 'voucher_info', 'amount', 'binded'
                ],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        type:  'вид платежа',
                        amount:  'сумма платежа',
                        cash: 'наличные',
                        'contractor.title': 'контрагент',
                        document_number:'№ п/п',
                        document_date:'дата п/п',
                        statement_number:'№ выписки',
                        statement_date:'дата выписки',
                        voucher_info:'счет и путевка',
                        invoice_number:'№ счета',
                        invoice_date:'дата счета',
                        binded: function(h) { return (
                            <i class="icon-shuffle" title="разнесение платежа"></i>
                        )}
                    },
                    sortable: ['id', 'created_at', 'contractor.title', 'document_date', 'statement_date'],
                    filterable: ['document_number', 'voucher_info', 'statement_number' ],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    perPageValues:[10,25,50,100,250,500,1000],
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll'
                    },
                    filterByColumn: true,
                    templates: {

                    },
                    customFilters: [
                        'range',
                        'contractor',
                        'type',
                        'hide_binded',
                    ],
                    initFilters: {
                        range:this.$store.state.paymentFilters.rangeFilter,
                        contractor:this.$store.state.paymentFilters.contractorFilter,
                        type:this.$store.state.paymentFilters.typeFilter,
                        hide_binded:this.$store.state.paymentFilters.bindingFilter,
                    },
                    columnsClasses: {
                        cash: 'center',
                        amount: 'right',
                        id: 'center',
                    },
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                },
                theme: 'bootstrap4',
                showPaymensDialog:false,
                showBindPaymenDialog:false,
                showUpladResultModal:false,

                rangeFilter: null,
                contractorFilter: null,
                typeFilter: null,
                bindingFilter: false,
                payment_in_edit:null,
                table_data:null,
            }
        },
        methods: {
            paymentTypeText: function (type) {
                return CONSTANTS.PAYMENT_TYPE_TEXT[type];
            },
            isIncome: function (type) {
                switch (type) {
                    case CONSTANTS.PAYMENT_TYPE_CLIENT: /* оплата клиенту агентству */
                    case CONSTANTS.PAYMENT_TYPE_AGENCY: /* оплата агентством системе */
                    case CONSTANTS.PAYMENT_TYPE_OBJECT_REFUND: /* возврат отелем системе  */
                    case CONSTANTS.PAYMENT_TYPE_OBJECT_FEE: /* выплата вознаграждения отелем системе */
                    case CONSTANTS.PAYMENT_TYPE_AGENCY_FEE_REFUND: /* возврат вознаграждения агентством системе */
                        return true;
                    case CONSTANTS.PAYMENT_TYPE_CLIENT_REFUND:  /* возврат агентством клиенту */
                    case CONSTANTS.PAYMENT_TYPE_AGENCY_REFUND: /* возврат системой агентству  */
                    case CONSTANTS.PAYMENT_TYPE_AGENCY_FEE: /* выплата вознаграждения системой агентству  */
                    case CONSTANTS.PAYMENT_TYPE_OBJECT: /* оплата системой отелю  */
                    case CONSTANTS.PAYMENT_TYPE_OBJECT_FEE_REFUND: /* возврат вознаграждения системой отелю  */
                        return false;

                    // const  = 9; /*   */

                    // const PAYMENT_TYPE_CLIENT_TO_AGENCY = 11; /* прочий платеж клиентом агентству */
                    // const PAYMENT_TYPE_AGENCY_TO_CLIENT = 12; /* прочий платеж агентством клиенту */
                    // const PAYMENT_TYPE_AGENCY_TO_SYSTEM = 13; /* прочий платеж агентством системе */
                    // const PAYMENT_TYPE_SYSTEM_TO_AGENCY = 14; /* прочий платеж системой агентству */
                    // const PAYMENT_TYPE_SYSTEM_TO_OBJECT = 15; /* прочий платеж системой отелю */
                    // const PAYMENT_TYPE_OBJECT_TO_SYSTEM = 16; /* прочий платеж отелем системе */

                }
            },
            applyRangeFilter: function() {
                this.saveFilter();
                Event.$emit('vue-tables.filter::range', this.rangeString);
            },
            resetRangeFilter: function() {
                this.rangeFilter = null;
                this.saveFilter();
            },
            applyContractorFilter: function() {
                this.saveFilter();
                Event.$emit('vue-tables.filter::contractor', this.contractorFilter);
            },
            applyTypeFilter: function() {
                this.saveFilter();
                Event.$emit('vue-tables.filter::type', this.typeFilter);
            },
            resetTypeFilter: function() {
                this.typeFilter = null;
                this.saveFilter();
            },
            applyBindingFilter: function() {
                this.saveFilter();
                Event.$emit('vue-tables.filter::hide_binded', this.bindingFilter?0:1);
            },
            resetBindingFilter: function() {
                this.bindingFilter = false;
                this.saveFilter();
            },
            saveFilter: function(){
                this.$store.commit('savePaymentFilters', {
                    typeFilter:this.typeFilter,
                    rangeFilter:this.rangeFilter,
                    contractorFilter:this.contractorFilter,
                    bindingFilter:this.bindingFilter,
                });
            },
            restoreFilter: function() {
                this.typeFilter = this.$store.state.paymentFilters.typeFilter;
                if (!this.typeFilter) this.typeFilter=null;

                this.contractorFilter = this.$store.state.paymentFilters.contractorFilter;
                if (!this.contractorFilter) this.contractorFilter=null;

                this.rangeFilter = Object.assign({}, this.$store.state.paymentFilters.rangeFilter);
                if (!this.rangeFilter) this.rangeFilter=null;

                console.log('bindingFilter', this.bindingFilter)
                this.bindingFilter = this.$store.state.paymentFilters.bindingFilter;
                if (!this.bindingFilter) this.bindingFilter=false;
                console.log('bindingFilter', this.bindingFilter)
            },
            getCompanies: function() {
                return this.companies;
            },
            onPaymentUploaded: function (upload_result) {
                this.$refs.paymentsTable.refresh();
                console.log(upload_result);
                this.upload_result = upload_result;
                this.showUpladResultModal = true;
            },
            onPaymentCreated: function () {
                this.$refs.paymentsTable.refresh();
            },
            bindPayment: function (payment) {
                console.log('bindPayment');
                this.payment_in_edit = payment;
                this.showBindPaymenDialog = true;
            },
            onPaymentSaved : function () {

            },
            reloadTable: function() {
                var table = this.$refs.paymentsTable;
                table.getData();
            },
            onCloseBindPaymenDialog: function (cmd) {
                this.reloadTable();
            }
        },
        computed: {
            rangeString: function () {
                if (this.rangeFilter !== null)
                    return (new Date(this.rangeFilter.start).toLocaleDateString()) + '_' + (new Date(this.rangeFilter.end).toLocaleDateString())
                return null;
            },
            get_types: function ()  {
                return this.getTypesForSystem();
            },
            total() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => {
                    if (this.isIncome(item.type))
                        return accum  + item.amount;
                    else
                        return accum  - item.amount;
                }, 0 )
            },

        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',(data)=>{ this.$eventHub.$emit('loading_end'); this.table_data = data.data; });
            this.loadCompanies();
        },
        mounted: function () {
            this.restoreFilter();
        },
    }
</script>
